import { Body, Title } from 'src/components/typography'
import { MenuWrapper } from './styled'
import { colors } from 'src/styles/theme'
import { RightOutlined } from '@ant-design/icons'
import { Flex } from 'antd'

interface MenuProps {
  label: string
  path: string
  isMobile?: boolean
  onMenuClick?: () => void
}

export const Menu = ({ label, path, isMobile = false, onMenuClick }: MenuProps) => {
  const handleClick = () => {
    if (onMenuClick) {
      onMenuClick()
    }
  }

  return (
    <MenuWrapper to={path} onClick={handleClick} $isMobile={isMobile}>
      {isMobile ? (
        <Flex justify="space-between" align="center" style={{ width: '100%' }}>
          <Body $color={colors.black}>{label}</Body>
          <RightOutlined style={{ color: colors.black }} />
        </Flex>
      ) : (
        <Title $level={6} $color={colors.black}>
          {label}
        </Title>
      )}
    </MenuWrapper>
  )
}
